exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapBox[data-v-59d4e8bf] {\n  width: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n.wrapBox .noDataBox[data-v-59d4e8bf] {\n  padding: 100px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.wrapBox .postInformationItem[data-v-59d4e8bf] {\n  width: 100%;\n  min-height: 0px;\n  overflow: hidden;\n  background: #fff;\n  margin-bottom: 10px;\n}\n", ""]);

// exports
